import React from 'react';

const IndustriesSection = () => {
  const industries = [
    {
      title: 'Banking & Finance',
      image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=400&q=80',
      desc: 'Core banking software, loan management, and compliance platforms.',
      color: '#6C63FF',
      tag: 'FinTech',
    },
    {
      title: 'Healthcare',
      image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=400&q=80',
      desc: 'HIPAA-compliant telemedicine apps, EHR systems, and medical AI.',
      color: '#EF4444',
      tag: 'HealthTech',
    },
    {
      title: 'Education',
      image: 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?auto=format&fit=crop&w=400&q=80',
      desc: 'LMS platforms, virtual classrooms, and automated exam portals.',
      color: '#F59E0B',
      tag: 'EdTech',
    },
    {
      title: 'Retail & E-Commerce',
      image: 'https://images.unsplash.com/photo-1556742049-0a6756574f88?auto=format&fit=crop&w=400&q=80',
      desc: 'Headless e-commerce, omnichannel POS, and inventory management.',
      color: '#10B981',
      tag: 'E-Commerce',
    },
    {
      title: 'Manufacturing',
      image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=400&q=80',
      desc: 'IoT sensor monitoring, ERP inventory, and supply chain tracking.',
      color: '#8B5CF6',
      tag: 'Industry 4.0',
    },
    {
      title: 'Food Tech',
      image: 'https://images.unsplash.com/photo-1526367790999-0150786686a2?auto=format&fit=crop&w=400&q=80',
      desc: 'Multi-vendor food marketplaces, kitchen automation, and rider routing.',
      color: '#00D4FF',
      tag: 'Food Tech',
    },
    {
      title: 'Government',
      image: 'https://images.unsplash.com/photo-1541872703-74c5e44368f9?auto=format&fit=crop&w=400&q=80',
      desc: 'Secure citizen portals, digital ID verification, and record management.',
      color: '#3B82F6',
      tag: 'GovTech',
    },
    {
      title: 'Insurance',
      image: 'https://images.unsplash.com/photo-1450133064473-71024230f91b?auto=format&fit=crop&w=400&q=80',
      desc: 'Claims automation, underwriting AI, and policyholder portals.',
      color: '#14B8A6',
      tag: 'InsurTech',
    },
    {
      title: 'Real Estate',
      image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=400&q=80',
      desc: 'PropTech platforms, virtual tours, and tenant management ERPs.',
      color: '#A855F7',
      tag: 'PropTech',
    },
    {
      title: 'Logistics & Supply Chain',
      image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=400&q=80',
      desc: 'Fleet tracking, route optimization, and automated warehouse WMS.',
      color: '#F97316',
      tag: 'SupplyChain',
    },
  ];

  return (
    <section
      id="industries"
      style={{
        padding: '56px 0',
        position: 'relative',
        zIndex: 2,
        background: '#060816',
      }}
    >
      <div className="ht-container">
        {/* Section Header */}
        <div className="section-header" style={{ marginBottom: '28px' }}>
          <span className="section-tag">INDUSTRIES WE SERVE</span>
          <h2 className="text-gradient" style={{ fontSize: 'clamp(1.8rem, 3.4vw, 2.6rem)', fontWeight: 800 }}>
            Tailored Engineering for Diverse Domains
          </h2>
          <p style={{ color: '#A3A8B8', fontSize: '0.98rem', maxWidth: '700px', margin: '6px auto 0 auto' }}>
            Domain-specific software solutions compliant with international regulations and global industry benchmarks.
          </p>
        </div>

        {/* Industry Cards Grid (Desktop: 5 cols, Tablet: 3 cols, Mobile: 2 cols) */}
        <div
          className="industries-grid-desktop"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(5, 1fr)',
            gap: '16px',
          }}
        >
          {industries.map((ind, idx) => (
            <div
              key={idx}
              className="glass-card"
              style={{
                padding: '14px',
                borderRadius: '16px',
                textAlign: 'left',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                background: 'rgba(15, 23, 42, 0.75)',
                transition: 'transform 0.25s ease, border-color 0.25s ease',
              }}
            >
              <div>
                {/* Small Cover Image Banner */}
                <div
                  style={{
                    position: 'relative',
                    width: '100%',
                    height: '84px',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    marginBottom: '12px',
                    background: 'rgba(6, 8, 22, 0.8)',
                    border: `1px solid ${ind.color}33`,
                  }}
                >
                  <img
                    src={ind.image}
                    alt={ind.title}
                    onError={(e) => {
                      e.currentTarget.style.display = 'none';
                    }}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      display: 'block',
                      filter: 'brightness(0.85)',
                    }}
                  />
                  {/* Subtle Gradient & Tag Overlay */}
                  <div
                    style={{
                      position: 'absolute',
                      inset: 0,
                      background: `linear-gradient(180deg, transparent 40%, rgba(6, 8, 22, 0.9) 100%)`,
                    }}
                  />
                  <span
                    style={{
                      position: 'absolute',
                      bottom: '6px',
                      left: '8px',
                      fontSize: '0.62rem',
                      fontWeight: 800,
                      color: ind.color,
                      textTransform: 'uppercase',
                      letterSpacing: '0.06em',
                      background: 'rgba(6, 8, 22, 0.85)',
                      padding: '2px 6px',
                      borderRadius: '4px',
                      border: `1px solid ${ind.color}44`,
                    }}
                  >
                    {ind.tag}
                  </span>
                </div>

                <h3 style={{ fontSize: '0.98rem', color: '#FFF', marginBottom: '6px', fontWeight: 800, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  {ind.title}
                </h3>
                <p style={{ fontSize: '0.8rem', color: '#A3A8B8', lineHeight: 1.45 }}>
                  {ind.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
